import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'shell/Dialog';
import { Button } from '@/components/ui/button';

export interface ConfirmationDialogConfig {
  id: string;
  title: string;
  description: string;
  confirmLabel: string;
  loadingLabel: string;
  variant?: 'default' | 'destructive';
  /** actionInProgress key that indicates this dialog's action is running */
  actionKey: string;
  onConfirm: () => void;
}

interface ConfirmationDialogProps {
  config: ConfirmationDialogConfig;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  actionInProgress: string | null;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  config,
  open,
  onOpenChange,
  actionInProgress,
}) => {
  const isLoading = actionInProgress === config.actionKey;
  const isDisabled = !!actionInProgress;

  const handleConfirm = () => {
    onOpenChange(false);
    config.onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-podcast border-border"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !isDisabled) handleConfirm();
        }}
      >
        <DialogHeader>
          <DialogTitle>{config.title}</DialogTitle>
          <DialogDescription>{config.description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isDisabled}
          >
            Cancel
          </Button>
          <Button
            variant={config.variant || 'default'}
            onClick={handleConfirm}
            disabled={isDisabled}
          >
            {isLoading ? config.loadingLabel : config.confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
